<template>
  <div id="tour-form" class="modal-form" v-if="formData">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <form class="formData-form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save & Publish"
                  @click="saveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="unpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="saveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
            <h1 class="form-title">Add/Edit Tour</h1>
            <fieldset>
              <legend>Basic information</legend>
              <div class="form-group row">
                <label for="title" class="form-label col-md-2"
                  >Tour Name *</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    v-model="$v.formData.title.$model"
                    required
                    :class="{
                      'is-invalid': $v.formData.title.$error,
                      'is-valid':
                        $v.formData.title.$error == false &&
                        $v.formData.title.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a title.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="organizer" class="form-label col-md-2"
                  >Organizer *</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    v-model="$v.formData.organizer.$model"
                    required
                    :class="{
                      'is-invalid': $v.formData.organizer.$error,
                      'is-valid':
                        $v.formData.organizer.$error == false &&
                        $v.formData.organizer.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">
                    Please enter an organizer name.
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="form-label col-md-2">Email *</label>
                <div class="col-md-10">
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    v-model="$v.formData.email.$model"
                    required
                    :class="{
                      'is-invalid': $v.formData.email.$error,
                      'is-valid':
                        $v.formData.email.$error == false &&
                        $v.formData.email.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a Email.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="form-label col-md-2">URL</label>
                <div class="col-md-10">
                  <input
                    type="url"
                    class="form-control"
                    id="websiteLink"
                    v-model="formData.websiteLink"
                  />
                </div>
              </div>
              <LocationPicker
                @change="onLocationPickerChanged"
                ref="locationPicker"
              />
              <div class="form-group row">
                <label for="latitude" class="form-label col-md-2"
                  >Location*</label
                >
                <div class="col-md-10">
                  <div class="form-group row">
                    <label for="latitude" class="form-label col-md-3">
                      <div class="label-icon-box">
                        <i class="label-icon fas fa-map-marker-alt"></i>
                      </div>
                      Latitude
                    </label>
                    <div class="col-md-3">
                      <input
                        type="number"
                        step="0.0000001"
                        class="form-control"
                        id="latitude"
                        min="-90"
                        max="90"
                        v-model="$v.formData.position.latitude.$model"
                        required
                        :class="{
                          'is-invalid': $v.formData.position.latitude.$error,
                          'is-valid':
                            $v.formData.position.latitude.$error == false &&
                            $v.formData.position.latitude.$model != '',
                        }"
                      />
                      <div class="invalid-feedback">
                        Please enter a valid latitude.
                      </div>
                    </div>
                    <label for="longitude" class="form-label col-md-2"
                      >Longitude</label
                    >
                    <div class="col-md-3">
                      <input
                        type="number"
                        step="0.001"
                        class="form-control"
                        id="longitude"
                        min="-180"
                        max="180"
                        v-model="$v.formData.position.longitude.$model"
                        required
                        :class="{
                          'is-invalid': $v.formData.position.longitude.$error,
                          'is-valid':
                            $v.formData.position.longitude.$error == false &&
                            $v.formData.position.longitude.$model != '',
                        }"
                      />
                      <div class="invalid-feedback">
                        Please enter a valid longitude.
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="what3words" class="form-label col-md-3">
                      <div class="label-icon-box">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21.265"
                          height="16.799"
                          viewBox="0 0 21.265 16.799"
                        >
                          <g transform="translate(-379.638 -183.044)">
                            <path
                              d="M380.873,199.843a1.236,1.236,0,0,1-1.162-1.655l5.168-14.328a1.235,1.235,0,0,1,2.324.838l-5.169,14.328A1.236,1.236,0,0,1,380.873,199.843Z"
                              fill="#fff"
                            />
                            <path
                              d="M411.208,199.843a1.236,1.236,0,0,1-1.162-1.655l5.168-14.328a1.235,1.235,0,0,1,2.324.838l-5.168,14.328A1.236,1.236,0,0,1,411.208,199.843Z"
                              transform="translate(-23.522 0)"
                              fill="#fff"
                            />
                            <path
                              d="M441.543,199.843a1.236,1.236,0,0,1-1.162-1.655l5.168-14.328a1.235,1.235,0,0,1,2.324.838L442.7,199.027A1.235,1.235,0,0,1,441.543,199.843Z"
                              transform="translate(-47.044 0)"
                              fill="#fff"
                            />
                          </g>
                        </svg>
                      </div>
                      What3Words
                    </label>
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="what3words"
                        v-model="formData.what3words"
                        ref="what3words"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="socialIdentifiers" class="form-label col-md-2"
                  >Hashtag *</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="socialIdentifiers"
                    v-model="$v.formData.socialIdentifiers.$model"
                    required
                    :class="{
                      'is-invalid': $v.formData.socialIdentifiers.$error,
                      'is-valid':
                        $v.formData.socialIdentifiers.$error == false &&
                        $v.formData.socialIdentifiers.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a Hashtag.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="description" class="form-label col-md-2"
                  >Description*</label
                >
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="description"
                    rows="4"
                    required
                    v-model="$v.formData.description.$model"
                    :class="{
                      'is-invalid': $v.formData.description.$error,
                      'is-valid':
                        $v.formData.description.$error == false &&
                        $v.formData.description.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a Hashtag.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="telephone" class="form-label col-md-2"
                  >Telephone Number</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="telephone"
                    v-model="formData.telephone"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Category*</legend>
              <CategoryPicker
                v-model="$v.formData.categories.$model"
                :class="{
                  'is-invalid': $v.formData.categories.$error,
                  'is-valid':
                    $v.formData.categories.$error == false &&
                    $v.formData.categories.$model != '',
                }"
              />
              <div class="invalid-feedback">Please select a Category.</div>
            </fieldset>
            <fieldset>
              <legend>Target Group*</legend>
              <TravelerTypePicker
                v-model="$v.formData.travelerTypes.$model"
                selectText="selectedTour"
                :class="{
                  'is-invalid': $v.formData.travelerTypes.$error,
                  'is-valid':
                    $v.formData.travelerTypes.$error == false &&
                    $v.formData.travelerTypes.$model != '',
                }"
              />
              <div class="invalid-feedback">Please select a Target Group.</div>
            </fieldset>
            <fieldset>
              <legend>Image</legend>
              <div>
                <ImageUploadButton
                  newColor="var(--tour-color)"
                  ref="imageUploader"
                  :imageUrl="
                    formData && formData.thumbnailUrl
                      ? formData.thumbnailUrl
                      : ''
                  "
                  @clear="onClearUploadImage"
                />
              </div>
            </fieldset>
            <fieldset>
              <legend>Itinerary</legend>
              <ItineraryControl v-model="formData.groups" />
            </fieldset>
            <fieldset>
              <legend>Distribution</legend>
              <div class="form-group row">
                <label
                  class="form-label col-md-2"
                  style="line-height: 1.2"
                ></label>
                <div class="col-md-10">
                  <DistributionPicker
                    :contentId="id"
                    buttonColor="var(--tour-color)"
                    @click:add="saveDraftWithoutClosing"
                  />
                </div>
              </div>
            </fieldset>
            <EnwokeDeclarationFieldset
              v-model="formData.isAcceptedEnwokeAgreement"
              @delete="onDelete"
              contentName="tour"
            />
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save & Publish"
                  @click="saveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="unpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="saveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, decimal } from "vuelidate/lib/validators";
import LocationPicker from "@/components/LocationPicker";
import CategoryPicker from "@/components/CategoryPicker";
import TravelerTypePicker from "@/components/TravelerTypePicker";
import ExperiencePicker from "@/components/ExperiencePicker";
import DistributionPicker from "@/components/DistributionPicker";
import EnwokeDeclarationFieldset from "@/components/EnwokeDeclarationFieldset";
import ItineraryControl from "@/components/ItineraryControl";
import ImageUploadButton from "@/components/ImageUploadButton";
import _ from "lodash";

export default {
  name: "ExperienceForm",
  components: {
    LocationPicker,
    CategoryPicker,
    TravelerTypePicker,
    ExperiencePicker,
    DistributionPicker,
    ItineraryControl,
    ImageUploadButton,
    EnwokeDeclarationFieldset,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      regions: [],
      districts: [],
      formData: {
        id: null,
        title: "",
        organizer: "",
        description: "",
        telephone: "",
        email: "",
        country: "",
        region: "",
        district: "",
        socialIdentifiers: "",
        groups: [],
        categories: [],
        travelerTypes: [],
        offers: [],
        mainImageUrl: "",
        thumbnailUrl: "",
        websiteLink: "",
        what3words: "",
        position: {
          latitude: "",
          longitude: "",
        },
        platforms: [],
        status: "PUBLISH",
        isAcceptedEnwokeAgreement: false,
      },
    };
  },
  computed: {
    id() {
      return this.content ? this.content.id : this.formData.id;
    },
  },
  validations: {
    formData: {
      title: {
        required,
      },
      organizer: {
        required,
      },
      email: {
        required,
        email,
      },
      country: {
        required,
      },
      region: {
        required,
      },
      position: {
        latitude: {
          valid: (val) => {
            if (val) {
              return isFinite(val) && Math.abs(val) <= 90;
            } else {
              return false;
            }
          },
        },
        longitude: {
          valid: (val) => {
            if (val) {
              return isFinite(val) && Math.abs(val) <= 180;
            } else {
              return false;
            }
          },
        },
      },
      socialIdentifiers: {
        required,
      },
      description: {
        required,
      },
      categories: {
        required,
      },
      travelerTypes: {
        required,
      },
    },
  },
  mounted() {
    if (this.content) {
      this.prepare(this.content);
    }
  },
  methods: {
    prepare(content) {
      const formData = _.merge({}, content); // Create a copy.

      if (!formData.position) {
        formData.position = {
          latitude: "",
          longitude: "",
        };
      }
      if (formData.categories && formData.categories.length > 0) {
        formData.categories = formData.categories.map((it) => it.id);
      }
      if (formData.travelerTypes && formData.travelerTypes.length > 0) {
        formData.travelerTypes = formData.travelerTypes.map((it) => it.id);
      }
      if (formData.platforms && formData.platforms.length > 0) {
        formData.platforms = formData.platforms.map((it) => it.id);
      }
      if (formData.country && formData.country.id) {
        formData.country = formData.country.id;
      }
      if (formData.region && formData.region.id) {
        formData.region = formData.region.id;
      }
      if (formData.district && formData.district.id) {
        formData.district = formData.district.id;
      }
      if (formData.groups && formData.groups.length > 0) {
        formData.groups.forEach((it) => {
          if (it.items && it.items) {
            it.items = it.items.map((item) => item.experience);
          }
        });
      }

      this.formData = formData;

      this.$refs.locationPicker.revalidate(formData);
    },
    async uploadImages() {
      if (this.$refs.imageUploader) {
        return this.$refs.imageUploader.upload();
      } else {
        return null;
      }
    },
    onSubmit(ev) {
      ev.preventDefault();
    },
    saveAndPublish(ev) {
      this.save("PUBLISH");
    },
    saveDraft() {
      this.save("DRAFT");
    },
    saveDraftWithoutClosing() {
      this.save("DRAFT", false);
    },
    unpublish() {
      this.save("UNPUBLISH");
    },
    async save(status = "PUBLISH", closeAfterSave = true) {
      if (!this.formData.isAcceptedEnwokeAgreement) return;

      this.formData.status = status;

      const files = await this.uploadImages();
      if (files && files.length > 0) {
        this.formData.mainImageUrl = files[0].url;
        this.formData.thumbnailUrl = files[0].url;
      }

      let promise = null;

      let saveData = _.merge({}, this.formData); // Clone data for saving.

      // Finalize save data.
      if (saveData.groups && saveData.groups.length > 0) {
        saveData.groups.forEach((group) => {
          if (group.items && group.items.length > 0) {
            group.items = group.items
              .filter((it) => it && (it.id || it.experience))
              .map((it) => ({
                title: "", // Placeholder for now
                description: "", // Placeholder for now
                experience: it.id || it.experience,
              }));
          }
        });
      }
      if (
        saveData.position &&
        saveData.position.latitude &&
        saveData.position.longitude
      ) {
        saveData.position.latitude = parseFloat(saveData.position.latitude);
        saveData.position.longitude = parseFloat(saveData.position.longitude);
      } else {
        delete saveData.position;
      }
      if (!saveData.country) {
        delete saveData.country;
      }
      if (!saveData.region) {
        delete saveData.region;
      }
      if (!saveData.district) {
        delete saveData.district;
      }

      this.$v.$touch();
      if (!this.$v.$invalid || status != "PUBLISH") {
        if (this.formData.id) {
          promise = this.$repo.tour.updateTour(saveData);
        } else {
          promise = this.$repo.tour.createTour(saveData);
        }

        promise
          .then((data) => {
            this.formData.id = data.id;
            if (closeAfterSave) {
              this.$toasted.show("Save data successfully.", {
                type: "success",
                duration: 3000,
                position: "bottom-right",
              });
              this.closeForm();
            }
          })
          .catch((err) => {
            console.error(err);
            if (closeAfterSave) {
              this.$toasted.show("Something went wrong.", {
                type: "error",
                duration: 3000,
                position: "bottom-right",
              });
            }
          });
      }
    },
    async onDelete() {
      if (this.id) {
        await this.$repo.tour.deleteTour(this.id);
        this.closeForm();
      }
    },
    onClearUploadImage() {
      this.formData.mainImageUrl = "";
      this.formData.thumbnailUrl = "";
    },
    onClickCloseButton(ev) {
      ev.preventDefault();
      this.closeForm();
    },
    closeForm() {
      this.$emit("close");
    },
    onLocationPickerChanged(data) {
      this.formData.country = data.country;
      this.formData.region = data.region;
      this.formData.district = data.district;
    },
  },
};
</script>

<style lang="scss">
$main-color: #c32aa3;

#tour-form {
  .form-title {
    color: $main-color;
  }

  .label-icon-box {
    background-color: #b9b9b9;
    color: #fff;
    display: inline-block;
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
    text-align: center;
    position: relative;

    .label-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .label-icon {
    font-size: 2rem;
  }

  #experience-form .form-title {
    color: $main-color;
  }

  input[type="submit"].btn-primary {
    background-color: $main-color;
    border-color: $main-color;
  }

  .experience-picker .vue-tags-input .ti-tag,
  .experience-picker .vue-tags-input .ti-selected-item,
  .picker-control li.selected {
    background-color: $main-color;
    border-color: $main-color;
  }
}
</style>
